<script>
import Nav from "../components/pc/nav.vue";
import Bottom from "../components/pc/bottom.vue";
import Float from "../components/pc/home/float.vue";

export default {
  data() {
    return {
      bannerFixed: false,
    };
  },
  components: {
    Nav,
    Bottom,
    Float,
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 80) {
        this.bannerFixed = true;
      } else {
        this.bannerFixed = false;
      }
    },
  },
};
</script>
<template>
  <div class="home">
    <Nav :isFixed="bannerFixed" :defaultInd="4"></Nav>
    <div class="cont">
      <h5>
        NOTICE OF OFFICE RELOCATION
        <span>October 24, 2023</span>
      </h5>
      <img class="banner" src="@/assets/img/notice-sub2.png" alt="" />
      <p class="b-20">Dear Valued Clients and Partners</p>
      <p class="strong b-20">NOTICE OF OFFICE RELOCATION</p>
      <p>
        We are pleased to inform you that our office will be moving to a new
        address effective November
      </p>
      <p class="b-20">
        20th 2023. Our office telephone number and email address will remain
        unchanged.
      </p>
      <p class="strong">The new address is 77, Opebi Street, Ikeja, Lagos.</p>
      <p class="b-20">
        Should you have any questions on the relocation, please feel free to
        contact us via:
      </p>
      <p class="blue">support@opaymfb.com</p>
      <p class="blue b-20">easemoni@opaymfb.com</p>
      <p>
        We would maintain a team at our former address that will guide and
        direct walk-in customers for a period of one month after this notice.
      </p>
      <p class="b-40">
        We look forward to seeing and serving you at our new facility
      </p>
      <p>Yours faithfully,</p>
      <p class="strong b-40">For: OPay Microfinance Bank Limited</p>
      <p>Tokunboh Aiyedun</p>
      <p>Managing Director</p>
    </div>
    <Bottom></Bottom>
    <Float />
    <el-backtop target=".home"></el-backtop>
  </div>
</template>
<style lang="scss" scoped>
.home {
  height: 100%;
}
.cont {
  padding: 148px 120px 72px;
  h5 {
    color: rgba(0, 0, 0, 0.85);
    font-size: 40px;
    font-weight: 500;
    line-height: 40px;
    position: relative;
    span {
      position: absolute;
      right: 0;
      bottom: 0;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
  }
  .banner {
    width: 100%;
    margin: 31px 0 40px;
  }

  p {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    &.blue {
      color: #1c58f5;
      font-weight: 500;
      text-decoration-line: underline;
    }
    &.strong {
      font-weight: 500;
    }
  }
  .img {
    position: relative;
    left: -8px;
    width: 205px;
    height: 62px;
    margin-bottom: 14px;
  }
}
.b-20 {
  margin-bottom: 20px;
}
.b-40 {
  margin-bottom: 40px;
}
</style>
